module.exports = __webpack_public_path__ + "static/media/lp-final.4514925f.png";